import api from '@/lib/api'
import { defineStore, acceptHMRUpdate } from 'pinia'
import { ref } from 'vue'

export const useObjectsStore = defineStore('objects', () => {
  const mappedObjects = ref([])
  const syncStatus = ref({})
  const numDbRows = ref({})
  const availableObjects = ref(/** @type {SwaggerModels.AvailableObjectsListDataInner[]} */ ([]))
  const fetchMappedObjects = async () => {
    mappedObjects.value = (await api.get('/hk/v1/configuration/mapped-objects')).data
  }
  const fetchAvailableObjects = (() => {
    let executing = false
    let response
    return async () => {
      if (!executing) {
        executing = true
        response = api.get('/hk/v1/configuration/available-objects?unmappedOnly=true')
          .then(x => (availableObjects.value = x.data))
          .then(() => (executing = false))
      } else return response
    }
  })()
  const fetchCurrentObject = async (objectName, includeFields = false, includeIndexes = false) => {
    const { data } = await api.get(`/hk/v1/configuration/mapped-objects/${objectName}?fields=${includeFields}&indexes=${includeIndexes}`)
    return data
  }
  const fetchObjectMetadata = async (objectName) => {
    const { data } = await api.get(`/hk/v1/configuration/objects-metadata/${objectName}`)
    return data
  }
  const updateSyncStatus = (objectName, status) => {
    syncStatus.value[objectName] = status
  }

  const updateDbRows = async ({ objectName, count }) => {
    numDbRows.value[objectName] = count
  }

  const updateSyncMinutes = async (objectName, syncMinutes) => {
    await api.post(`/hk/v1/configuration/mapped-objects/${objectName}/syncMinutes`, { syncMinutes })
  }

  const updateStopSync = async (objectName, stopSync) => {
    await api.post(`/hk/v1/configuration/mapped-objects/${objectName}/stopSync`, { stopSync })
    if (!stopSync) await syncObject(objectName, false)
    mappedObjects.value.find(el => el.objectName === objectName).stopSync = stopSync
  }

  const getDefaultNewSObjectMapping = (objectAPIName) => {
    return {
      objectName: objectAPIName,
      isNewSetup: true,
      fields: []
    }
  }
  const saveMappingChangesToDB = async (/** @type {String} */ objectAPIName, /** @type {SwaggerModels.ObjectFieldsMapping} */ changes) => {
    return await api.post(`/hk/v1/configuration/mapped-objects/${objectAPIName}`, changes)
  }
  const deleteObjectMappingFromDB = async (/** @type {String} */ objectAPIName) => {
    await api.delete(`/hk/v1/configuration/mapped-objects/${objectAPIName}`)
    delete numDbRows.value[objectAPIName]
  }
  const refreshObjectData = async (/** @type {String} */ objectAPIName) => {
    const { data } = await api.get(`/hk/v1/configuration/mapped-objects/${objectAPIName}`)
    const obj = mappedObjects.value.find(o => o.objectName === objectAPIName)
    obj.numSFRows = data.numSFRows
    obj.numDbRows = data.numdbrows
  }
  const syncObject = async (/** @type {String} */ objectAPIName, syncAllRecords) => {
    return await api.post(`/hk/v1/configuration/sync/object/${objectAPIName}/new`, { syncAllRecords })
  }
  return {
    mappedObjects,
    availableObjects,
    numDbRows,
    syncStatus,
    fetchMappedObjects,
    fetchCurrentObject,
    fetchAvailableObjects,
    fetchObjectMetadata,
    updateSyncStatus,
    updateSyncMinutes,
    updateStopSync,
    getDefaultNewSObjectMapping,
    saveMappingChangesToDB,
    deleteObjectMappingFromDB,
    refreshObjectData,
    syncObject,
    updateDbRows
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useObjectsStore, import.meta.hot))
}
